var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vCarousel-item"},[_c('img',{attrs:{"src":require('@/assets/img/' + _vm.item_data.img),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }